import { StrapiDocument } from '../../General';


export enum FaqType  {
    General = 'general',
    Administration = 'administration',
    Association = 'association',
    Company = 'company'
}

export interface RFaq extends StrapiDocument {
    title: string;
    description: string;
    type: FaqType;
}
